import type { SubmissionPage } from '../../lib/types.ts';
import { COLORS, mono } from './styles.ts';
import { NavBtn } from '../takeoff/primitives.tsx';

interface Props {
  pageIndex: number;
  pageCount: number;
  pages: readonly SubmissionPage[];
  onChange: (i: number) => void;
}

export function PagePicker({ pageIndex, pageCount, pages, onChange }: Props) {
  const meta = pages.find((p) => p.page_index === pageIndex);
  const canPrev = pageIndex > 0;
  const canNext = pageCount > 0 && pageIndex < pageCount - 1;
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
        <NavBtn disabled={!canPrev} onClick={() => onChange(Math.max(0, pageIndex - 1))}>
          ←
        </NavBtn>
        <span style={mono(12, COLORS.textMuted)}>
          Page {pageIndex + 1}
          {pageCount > 0 ? ` / ${pageCount}` : ''}
        </span>
        <NavBtn disabled={!canNext} onClick={() => onChange(pageIndex + 1)}>
          →
        </NavBtn>
      </div>
      {meta && (
        <div style={{ ...mono(11, COLORS.textDim), marginTop: 4 }}>
          {meta.page_label ? `${meta.page_label} · ` : ''}
          {meta.category ?? 'unclassified'}
        </div>
      )}
    </div>
  );
}
